import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import NewUserBackButton from '../NewUserBackButton';

const CART_PATH = '/approved-with-cart';

// In-store VCC: the payment screen is reached from the cart, so Back returns to it
// (window.history.back() could land on the pricing or agreement step instead).
export default function CartBackButton() {
  const history = useHistory();
  const location = useLocation();

  if (location.pathname !== '/checkout') {
    return null;
  }

  return (
    <div className="k-cart-back">
      <NewUserBackButton text="Back to cart" onClick={() => history.push(CART_PATH)} />
    </div>
  );
}
